import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfirmProvider, ToastProvider } from '../components/ui';
import { useSession } from '../lib/session';
import { initSentry } from '../lib/sentry';
import { RootErrorBoundary } from './RootErrorBoundary';
import { router } from './router';

initSentry();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false } },
});

export function App() {
  const boot = useSession((s) => s.boot);
  useEffect(() => {
    void boot();
  }, [boot]);
  return (
    <RootErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ConfirmProvider>
            <RouterProvider router={router} />
          </ConfirmProvider>
        </ToastProvider>
      </QueryClientProvider>
    </RootErrorBoundary>
  );
}
